// Whitespace-tolerant text search shared by every search box in the app.
//
// A plain `haystack.includes(searchTerm)` only matches when the typed words are
// literally adjacent in the haystack, so "jul ilum" would never find Illumin's
// July campaign — the fields are concatenated in a fixed order (and often with a
// campaign ID between them). Splitting the query into tokens and requiring every
// token to appear somewhere makes word order and field order irrelevant.

/** Split a raw search input into lowercased, non-empty tokens. */
export function tokenizeSearch(searchTerm) {
  return String(searchTerm ?? '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
}

/** True when every token appears somewhere in `haystack` (order-independent). */
export function matchesAllTokens(haystack, tokens) {
  if (!tokens.length) return true;
  const text = String(haystack ?? '').toLowerCase();
  return tokens.every((token) => text.includes(token));
}

/**
 * Convenience for the common case: one raw search term against one haystack
 * string. Prefer tokenizeSearch + matchesAllTokens inside a filter loop so the
 * query is only tokenized once.
 */
export function matchesSearch(haystack, searchTerm) {
  return matchesAllTokens(haystack, tokenizeSearch(searchTerm));
}
